<template>
  <div>
    <Modal
      v-model="modal"
      :title="
        !backPlanWarningForm.id
          ? this.$t('alarms.backPlan.addBackupPlanAlarm')
          : this.$t('alarms.backPlan.editBackupPlanAlarm')
      "
      @on-cancel="cancel"
      @on-ok="ok"
      :loading="loading"
      :mask-closable="false"
      :styles="{ top: '65px' }"
      width="1000px"
      :footer-hide="true"
      :closable="false"
    >
      <Form
        ref="backPlanWarningForm"
        :model="backPlanWarningForm"
        :label-width="110"
        :rules="ruleValidate"
      >
        <!-- 下一步 -->
        <div v-show="isNext">
          <!-- 微信警告 -->
          <wechat-warning
            v-if="wechatWarningVisible"
            ref="wechatWarning"
          ></wechat-warning>
          <!-- 电话警告 -->
          <phone-warning
            v-if="phoneWarningVisible"
            ref="wechatWarning"
          ></phone-warning>
          <!-- 规则名称 -->
          <FormItem
            :label="$t('alarms.common.ruleName')"
            prop="ruleName"
            v-if="isEditRuleName"
          >
            <Row>
              <Col span="11">
                <Input
                  type="text"
                  v-model="backPlanWarningForm.ruleName"
                  placeholder="Enter something..."
                  style="width: 300px"
                  :disabled="isEdit"
                ></Input>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则名称 -->
          <FormItem :label="$t('alarms.common.ruleName')" v-if="showRuleName">
            <Row>
              <Col span="24">
                <div>{{ this.backPlanWarningForm.ruleName }}</div>
              </Col>
            </Row>
          </FormItem>

          <!-- 监控方式 -->
          <FormItem
            :label="$t('alarms.common.monitoringMethod')"
            prop="monitorMode"
          >
            <RadioGroup
              v-model="backPlanWarningForm.monitorMode"
              @on-change="changeMonitorMode()"
            >
              <Radio
                v-for="item in monitorModeList"
                :label="item.id"
                :key="item.id"
                >{{ item.name }}</Radio
              >
            </RadioGroup>
          </FormItem>

          <!-- 规则描述 -->
          <FormItem :label="$t('alarms.common.ruleDescription')">
            <Row :gutter="4">
              <!-- 监控指标 -->
              <Col span="4">
                <FormItem prop="monitorIndex">
                  <Select
                    v-model="backPlanWarningForm.monitorIndex"
                    @on-change="
                      changeMonitorIndex(backPlanWarningForm.monitorIndex)
                    "
                    :placeholder="$t('alarms.common.pleaseSelect')"
                  >
                    <Option
                      :value="item.id"
                      v-for="item in monitorIndexList"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <!-- 周期 -->
              <Col span="3">
                <FormItem prop="cycle">
                  <Select
                    v-model="backPlanWarningForm.cycle"
                    :placeholder="$t('alarms.common.cycle')"
                    @on-change="changeCycle(backPlanWarningForm.cycle)"
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in cycleList"
                      v-bind:key="index"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <!-- 连续周期 -->
              <Col span="3">
                <FormItem prop="continousCycle">
                  <Select
                    v-model="backPlanWarningForm.continousCycle"
                    :placeholder="$t('alarms.common.continuousCycle')"
                    @on-change="
                      changeContinousCycle(backPlanWarningForm.continousCycle)
                    "
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in continousCycleList"
                      v-bind:key="index"
                    >
                      {{ item.name }}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 统计数值 -->
              <Col span="3">
                <FormItem prop="statisticsValue">
                  <Select
                    v-model="backPlanWarningForm.statisticsValue"
                    :placeholder="$t('alarms.common.statisticsValue')"
                    @on-change="
                      changeStatisticsValue(backPlanWarningForm.statisticsValue)
                    "
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in statisticsValueList"
                      v-bind:key="index"
                    >
                      {{ item.name }}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 统计次数 -->
              <div v-if="isShowStatisticsCount">
                <Col span="3">
                  <FormItem prop="statisticsCount">
                    <Select
                      v-model="backPlanWarningForm.statisticsCount"
                      :placeholder="$t('alarms.common.statisticsCount')"
                      @on-change="
                        changeStatisticsCount(
                          backPlanWarningForm.statisticsCount
                        )
                      "
                    >
                      <Option
                        :value="item.id"
                        v-for="(item, index) in statisticsCountList"
                        v-bind:key="index"
                      >
                        {{ item.name }}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
              </div>
              <!-- 如果监控指标为备份计划时 不显示符号、阈值和单位 -->
              <div v-if="this.isShowField != 1">
                <!-- 关系符号 -->
                <Col span="2">
                  <FormItem prop="relationshipSign">
                    <Select
                      v-model="backPlanWarningForm.relationshipSign"
                      @on-change="
                        changeRelationshipSign(
                          backPlanWarningForm.relationshipSign
                        )
                      "
                      :placeholder="$t('alarms.common.symbol')"
                    >
                      <Option
                        :value="item.id"
                        v-for="(item, index) in relationshipSignList"
                        v-bind:key="index"
                      >
                        {{ item.name }}
                      </Option>
                    </Select>
                  </FormItem>
                </Col>
                <!-- 阈值 -->
                <Col span="3">
                  <FormItem prop="thresholdValue">
                    <Input
                      v-model="backPlanWarningForm.thresholdValue"
                      :placeholder="$t('alarms.common.threshold')"
                      type="number"
                    >
                    </Input>
                  </FormItem>
                </Col>
                <!-- 单位 -->
                <Col span="2">
                  <FormItem prop="unit">
                    <Input
                      v-model="backPlanWarningForm.unit"
                      disabled
                      :placeholder="$t('alarms.common.unit')"
                    >
                    </Input>
                  </FormItem>
                </Col>
              </div>
              <div v-else-if="this.isShowField == 2">
                <!-- 最小值 -->
                <Col span="3">
                  <FormItem prop="minValue">
                    <Input
                      v-model="backPlanWarningForm.minValue"
                      :placeholder="$t('alarms.common.minimum')"
                      type="number"
                    >
                    </Input>
                  </FormItem>
                </Col>
                <!-- 最大值 -->
                <Col span="3">
                  <FormItem prop="maxValue">
                    <Input
                      v-model="backPlanWarningForm.maxValue"
                      :placeholder="$t('alarms.common.max')"
                      type="number"
                    >
                    </Input>
                  </FormItem>
                </Col>
                <!-- 单位 -->
                <Col span="2">
                  <FormItem prop="unit">
                    <Input
                      v-model="backPlanWarningForm.unit"
                      disabled
                      :placeholder="$t('alarms.common.unit')"
                    ></Input>
                  </FormItem>
                </Col>
              </div>
            </Row>
          </FormItem>
          <div v-show="isShowLogGroupName">
            <FormItem
              :label="$t('alarms.common.logGroupName')"
              prop="logGroupName"
              style="width: 300px"
            >
              <Input
                v-model="logGroupName"
                :placeholder="$t('alarms.common.logGroupName')"
              ></Input>
            </FormItem>
          </div>

          <!-- 联系方式 -->
          <FormItem :label="$t('alarms.common.contactType')" prop="contactType">
            <RadioGroup
              v-model="backPlanWarningForm.contactType"
              @on-change="changeContactType(backPlanWarningForm.contactType)"
              placeholder=""
            >
              <Radio
                v-for="item in contactTypeList"
                :label="item.type"
                :key="item.value"
                >{{ item.label }}</Radio
              >
            </RadioGroup>
          </FormItem>

          <!-- 通知对象 -->
          <FormItem
            :label="$t('alarms.common.notificationObject')"
            prop="notificationObject"
            v-if="backPlanWarningForm.contactType == 0"
          >
            <Select
              v-model="backPlanWarningForm.notificationObject"
              multiple
              style="width: 300px"
              @on-change="changeNotificationObject"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in notificationObjectList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 联系人组 -->
          <FormItem
            :label="$t('alarms.common.contactGroup')"
            prop="contactGroupIds"
            v-if="backPlanWarningForm.contactType == 1"
          >
            <Select
              v-model="backPlanWarningForm.contactGroupIds"
              multiple
              style="width: 300px"
              @on-change="
                changeContactGroupId(backPlanWarningForm.contactGroupIds)
              "
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in contactGroupIdList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 报警方式 -->
          <FormItem :label="$t('alarms.common.noticeType')" prop="noticeType">
            <Select
              v-model="backPlanWarningForm.noticeType"
              multiple
              style="width: 300px"
              @on-change="selectnoticeType(backPlanWarningForm.noticeType)"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in alarmWayList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 企业微信机器人URL -->
          <FormItem
            :label="$t('alarms.common.enterpriseWeChatRobotURL')"
            prop="enterpriseWechatRobotIds"
            v-if="
              backPlanWarningForm.noticeType.filter(function (e) {
                return e == 3;
              }).length != 0
            "
          >
            <Select
              v-model="backPlanWarningForm.enterpriseWechatRobotIds"
              multiple
              style="width: 300px"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in enterpriseWechatRobotIdsList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 延迟告警 -->
          <FormItem :label="$t('alarms.common.alarmDelay')" prop="alarmDelay">
            <Select
              v-model="backPlanWarningForm.alarmDelay"
              style="width: 300px"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in alarmDelayList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 监控时段 -->
          <FormItem
            :label="$t('alarms.common.monitorPeriod')"
            prop="monitorPeriod"
          >
            <Select
              v-model="backPlanWarningForm.monitorPeriod"
              style="width: 300px"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in monitorPeriodList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 邮箱模板 -->
          <div v-show="isShowEmail">
            <FormItem :label="$t('alarms.common.emailModal')" prop="emailModal">
              <Input
                v-model="backPlanWarningForm.emailModal"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                style="width: 665px"
                disabled
              ></Input>
            </FormItem>
          </div>

          <!-- 企业微信模板 -->
          <div v-show="isShowWeChat">
            <FormItem
              :label="$t('alarms.common.wechatModal')"
              prop="wechatModal"
            >
              <Input
                v-model="backPlanWarningForm.wechatModal"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                style="width: 665px"
                disabled
              ></Input>
            </FormItem>
          </div>
          <!-- 电话模板 -->
          <div v-show="isShowPhone">
            <FormItem :label="$t('alarms.common.phoneModal')" prop="phoneModal">
              <Input
                v-model="backPlanWarningForm.phoneModal"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                style="width: 665px"
                disabled
              ></Input>
            </FormItem>
          </div>
          <div style="height: 42px">
            <Button
              type="primary"
              size="large"
              style="float: right"
              @click="ok('backPlanWarningForm')"
              :loading="addloading"
              :disabled="isAddOrEdit"
            >
              {{
                !backPlanWarningForm.id
                  ? this.$t("common.addAlarm")
                  : this.$t("common.editAlarm")
              }}
            </Button>
            <Button
              size="large"
              style="float: right; margin-right: 10px"
              @click="cancel('backPlanWarningForm')"
              >{{ $t("alarms.common.cancel") }}
            </Button>
            <Button
              size="large"
              @click="previousPage"
              style="float: right; margin-right: 10px"
              >{{ $t("alarms.common.lastStep") }}
            </Button>
          </div>
        </div>

        <!-- 上一步 -->
        <div v-show="isPrevious">
          <div>
            <Row :gutter="16">
              <Col span="8">
                <!-- 账户 -->
                <FormItem
                  :label="$t('alarms.common.account')"
                  prop="account"
                  :label-width="70"
                >
                  <Select
                    v-model="backPlanWarningForm.account"
                    @on-change="changeAccount(backPlanWarningForm.account)"
                    :transfer="true"
                    :placeholder="$t('alarms.common.pleaseSelect')"
                  >
                    <Option
                      :value="item.id"
                      @click.native="getMoreParams(item)"
                      v-for="(item, index) in accountList"
                      v-bind:key="index"
                      >{{ item.name }}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="8" style="z-index: 200" v-if="accountType != 3">
                <!-- 存储区域 -->
                <FormItem
                  :label="$t('alarms.common.region')"
                  prop="backupRegion"
                >
                  <Select
                    @on-change="
                      changebackupRegion(backPlanWarningForm.backupRegion)
                    "
                    v-model="backPlanWarningForm.backupRegion"
                    multiple
                    :max-tag-count="1"
                    :transfer="true"
                    :placeholder="$t('alarms.common.pleaseSelect')"
                  >
                    <Checkbox
                      v-model="singleBackupRegion"
                      @on-change="selectBackupRegionAll"
                      style="display: block; text-align: right"
                    >
                      {{ $t("alarms.common.allSelected") }}
                    </Checkbox>
                    <Option
                      :value="item.name"
                      v-for="item in backupRegionList"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Button
                type="primary"
                style="float: right"
                v-show="isShowSearch"
                @click="searchBackPlanDate('backPlanWarningForm')"
                >{{ $t("alarms.common.search") }}
              </Button>
            </Row>
          </div>

          <v-table
            :height="459"
            column-width-drag
            is-horizontal-resize
            style="width: 100%; height: 459px; margin-bottom: 15px"
            :columns="column"
            :table-data="tableBackPlanDate"
            row-hover-color="#edf7ff"
            :is-loading="modal_loadings"
            title-bg-color="#f8f8f9"
            :select-group-change="selectChange"
            :select-all="selectAll"
          ></v-table>
          <div style="height: 42px">
            <Button
              type="primary"
              size="large"
              @click="nextPage"
              style="float: right"
              :disabled="isNextClick"
              >{{ $t("alarms.common.nextStep") }}
            </Button>
            <Button
              size="large"
              style="margin-right: 10px; float: right"
              @click="cancel('backPlanWarningForm')"
              >{{ $t("alarms.common.cancel") }}
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  </div>
</template>
<script>
import WechatWarning from "../common/WechatWarning.vue";
import PhoneWarning from "../common/PhoneWarning.vue";
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import TableBackPlan from "../backPlan/TableBackPlan";

var tableBackPlan = TableBackPlan;
var tableDataWarningVue = {};
export default {
  inject: ["reload"],
  components: {
    WechatWarning,
    PhoneWarning,
  },
  data() {
    // 名字是否重复
    var validNameRepeatedCheck = (rule, value, callback) => {
      var self = this;
      self.$api.alertRule
        .nameRepeatedCheck({
          alertRuleName: this.backPlanWarningForm.ruleName,
          monitorModule: this.monitorModule,
        })
        .then((res) => {
          if (res.status == 200) {
            callback();
          }
        })
        .catch((err) => {
          if (err.status == 400) {
            callback(new Error(this.$t("monitor.alarmRule.ruleNameRepeated")));
          }
        });
    };
    return {
      monitorModule: 45,
      monitorItemId: "",
      isShowStatisticsCount: false,
      isAddOrEdit: true,
      wechatWarningVisible: false,
      phoneWarningVisible: false,
      contactTypeList: [
        {
          label: this.$t("alarms.common.contactPerson"),
          value: "contact",
          type: 0,
        },
        {
          label: this.$t("alarms.common.contactGroup"),
          value: "contactGroup",
          type: 1,
        },
      ],
      accountType: "",
      addloading: false,
      singleBackupRegion: false,
      alarmDelayList: [],
      monitorPeriodList: [],
      isEdit: false,
      isShowSearch: false,
      isEditRuleName: false,
      showRuleName: false,
      modal_loadings: false,
      isShowField: "", //是否显示符号、阈值和单位
      isShowEmail: false,
      isShowWeChat: false,
      isShowPhone: false,
      isNext: false,
      isPrevious: true,
      selection: [],
      accountList: [],
      notificationObjectList: [],
      alarmWayList: [],
      backupRegionList: [],
      loading: true,
      modal: false,
      modal_loading: false,
      exportDataList: "",
      noticeType: [],
      units: "",
      isNextClick: true, //禁止点击下一步
      unit: "",
      isShowLogGroupName: false,
      logGroupName: "",
      monitorModeList: [
        {
          id: 0,
          name: this.$t("alarms.common.routineMonitoring"),
        },
        {
          id: 1,
          name: this.$t("alarms.common.intervalMonitoring"),
        },
      ],
      backPlanWarningForm: {
        monitorMode: 0,
        minValue: "",
        maxValue: "",
        account: "",
        ruleName: "",
        notificationObject: [],
        noticeType: [],
        emailModal: "",
        wechatModal: "",
        phoneModal: "",
        thresholdValue: "",
        monitorIndex: "",
        cycle: "",
        continousCycle: "",
        statisticsValue: "",
        statisticsCount: "",
        relationshipSign: "",
        unit: "",
        backupRegion: [],
        alarmDelay: "",
        monitorPeriod: "",
        contactType: 0,
        contactGroupIds: [],
        userIdList: [],
        idList: [],
        enterpriseWechatRobotIds: [],
      },
      enterpriseWechatRobotIdsList: [],
      // 联系人组
      contactGroupIdList: [],
      // 监控指标
      monitorIndexList: [],
      // 周期
      cycleList: [],
      // 连续周期
      continousCycleList: [],
      // 统计数值
      statisticsValueList: [],
      // 统计次数
      statisticsCountList: [],
      // 关系符号
      relationshipSignList: [],
      ruleValidate: {
        account: [
          {
            required: true,
            message: this.$t("monitor.alarmRule.accountRequired"),
            trigger: "change",
            type: "number",
          },
        ],
        alarmDelay: [
          {
            required: true,
            message: this.$t("monitor.alarmRule.alarmDelayRequired"),
            trigger: "change",
            type: "number",
          },
        ],
        monitorPeriod: [
          {
            required: true,
            message: this.$t("monitor.alarmRule.monitorPeriodRequired"),
            trigger: "change",
            type: "number",
          },
        ],
        backupRegion: [
          {
            required: true,
            type: "array",
            message: this.$t("monitor.alarmRule.regionRequired"),
            trigger: "change",
          },
        ],
        ruleName: [
          { required: true, message: this.$t("monitor.alarmRule.ruleNameRequired"), trigger: "blur" },
          {
            type: "string",
            message: this.$t("monitor.alarmRule.ruleNamePattern"),
            pattern: "^[^ ]{2,20}$",
            trigger: "blur",
          },
          { validator: validNameRepeatedCheck, trigger: "blur" },
        ],
        notificationObject: [
          {
            required: true,
            type: "array",
            message: this.$t("monitor.alarmRule.notificationObjectRequired"),
            trigger: "change",
          },
        ],
        noticeType: [
          {
            required: true,
            type: "array",
            min: 1,
            message: this.$t("monitor.alarmRule.noticeTypeRequired"),
            trigger: "change",
          },
        ],
        monitorIndex: [
          {
            required: false,
            message: this.$t("monitor.alarmRule.monitorIndexRequired"),
            trigger: "change",
            type: "number",
          },
        ],
        cycle: [
          {
            required: true,
            message: this.$t("monitor.alarmRule.cycleRequired"),
            trigger: "change",
            type: "number",
          },
        ],
        continousCycle: [
          {
            required: true,
            message: this.$t("monitor.alarmRule.continousCycleRequired"),
            trigger: "change",
            type: "number",
          },
        ],
        statisticsValue: [
          {
            required: true,
            message: this.$t("monitor.alarmRule.statisticsValueRequired"),
            trigger: "change",
            type: "number",
          },
        ],
        statisticsCount: [
          {
            required: true,
            message: this.$t("monitor.ec2.warning.rule.statisticsCountRequired"),
            trigger: "change",
            type: "number",
          },
        ],
        relationshipSign: [
          {
            required: true,
            message: this.$t("monitor.alarmRule.relationshipSignRequired"),
            trigger: "change",
            type: "number",
          },
        ],
        thresholdValue: [{ required: true, message: this.$t("monitor.alarmRule.thresholdRequired") }],
        contactType: [
          {
            required: true,
            message: this.$t("monitor.alarmRule.contactTypeRequired"),
            trigger: "change",
            type: "number",
          },
        ],
        enterpriseWechatRobotIds: [
          {
            required: true,
            type: "array",
            message: this.$t("monitor.alarmRule.enterpriseWechatRobotRequired"),
            trigger: "change",
          },
        ],
        monitorMode: [
          {
            required: true,
            message: this.$t("monitor.ec2.warning.rule.monitorModeRequired"),
            trigger: "change",
            type: "number",
          },
        ],
        contactGroupIds: [
          {
            required: true,
            message: this.$t("monitor.alarmRule.contactGroupRequired"),
            trigger: "change",
            type: "array",
          },
        ],
      },
      column: [
        {
          width: 60,
          titleAlign: "center",
          columnAlign: "center",
          type: "selection",
        },
        {
          field: "backupPlanId",
          title: this.$t("alarms.backPlan.backupPlanId"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
        },
        {
          field: "backupPlanName",
          title: this.$t("alarms.backPlan.backupPlanName"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
        },
        {
          field: "creationDate",
          title: this.$t("alarms.backPlan.creationDate"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
        },
        {
          field: "region",
          title: this.$t("alarms.instance.region"),
          width: 80,
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
        },
      ],
      tableBackPlanDate: [],
      newTableBackPlanDataList: [],
      instanceList: [],
      awsBackupPlanDTOList: [],
    };
  },

  beforeCreate: function () {
    tableDataWarningVue = this;
  },
  methods: {
    //显示表格数据
    /****************************************************************/
    // 下一步
    nextPage: function () {
      this.isNext = true;
      this.isPrevious = false;
      // 查询监控指标
      tableDataWarningVue.searchMonitorIndex();
      // 查询阈值
      tableDataWarningVue.selectMonitorIndexDefault();
      // 查询联系人组
      tableDataWarningVue.listContactGroups();
    },
    // 上一步
    previousPage: function () {
      this.isNext = false;
      this.isPrevious = true;
    },
    init: function (id) {
      this.backPlanWarningForm.id = id || 0;
      // 根据用户名查询Account列表
      tableDataWarningVue.getAccount();
      this.$nextTick(() => {
        // 重置表单
        this.$refs["backPlanWarningForm"].resetFields();
        // 编辑
        if (this.backPlanWarningForm.id) {
          // 编辑显示不能输入的规则名称
          this.showRuleName = true;
          this.isEdit = true;
          this.isShowSearch = false;
          this.$api.alertRule
            .selectAlertRule("id", this.backPlanWarningForm.id)
            .then((res) => {
              //延时
              this.backPlanWarningForm.alarmDelay = res.data.delay;
              //监控时段
              this.backPlanWarningForm.monitorPeriod = res.data.monitorPeriod;
              // 账户
              /******************************************************/
              this.backPlanWarningForm.account = res.data.accountId;
              tableDataWarningVue.$api.account
                .queryAccountRegions(
                  "accountId",
                  this.backPlanWarningForm.account
                )
                .then((res) => {
                  this.backupRegionList = res.data;
                });

              // 查询通知对象
              tableDataWarningVue.$api.contact
                .queryContactsByAccountIdAndMonitorModule({
                  monitorModule: this.monitorModule,
                  accountId: this.backPlanWarningForm.account,
                })
                .then((res) => {
                  this.notificationObjectList = res.data.contactList;
                });

              // 账号类型
              this.accountType = res.data.accountType;

              this.modal_loadings = true;
              setTimeout(() => {
                // 存储区域
                this.backPlanWarningForm.backupRegion = res.data.regions;
                this.newTableBackPlanDataList = res.data.instanceList;
                // 实例列表
                /******************************************************/
                this.instanceList = res.data.instanceList;

                this.awsBackupPlanDTOList = res.data.awsBackupPlanDTOList;

                // 根据AccountId查询Instance列表
                var queryDate = {
                  accountId: this.backPlanWarningForm.account,
                };
                if (
                  this.accountType == 0 ||
                  this.accountType == 1 ||
                  this.accountType == 2 ||
                  this.accountType == 4
                ) {
                  queryDate.regions = this.backPlanWarningForm.backupRegion;
                }
                tableDataWarningVue.$api.resourceAwsBackupPlan
                  .queryBackupPlans(queryDate)
                  .then((res) => {
                    this.tableBackPlanDate = res.data;
                    console.log(res.data, "data");
                    this.modal_loadings = false;
                    for (var i = 0; i < this.tableBackPlanDate.length; i++) {
                      for (
                        var j = 0;
                        j < this.awsBackupPlanDTOList.length;
                        j++
                      ) {
                        if (
                          this.tableBackPlanDate[i].backupPlanId ==
                          this.awsBackupPlanDTOList[j].backupPlanId
                        ) {
                          this.tableBackPlanDate[i]._checked = true;
                        }
                      }
                    }
                    // 选了数据 可以点击下一步
                    if (
                      this.tableBackPlanDate.length == 0 ||
                      this.awsBackupPlanDTOList.length == 0
                    ) {
                      this.isNextClick = true;
                    } else {
                      this.isNextClick = false;
                    }
                  });
              }, 1000);

              // 规则名称
              this.monitorItemId = res.data.monitorItemId;
              this.backPlanWarningForm.ruleName = res.data.alertRuleName;

              // 监控指标
              /******************************************************/
              this.backPlanWarningForm.monitorIndex = res.data.monitorIndex;
              // 周期
              this.backPlanWarningForm.cycle = res.data.cycle;
              // 连续周期
              this.backPlanWarningForm.continousCycle = res.data.continousCycle;
              // 统计数值
              this.backPlanWarningForm.statisticsValue =
                res.data.statisticsValue;
              // 符号
              this.backPlanWarningForm.relationshipSign =
                res.data.relationshipSign;
              // 阈值
              this.backPlanWarningForm.thresholdValue = res.data.thresholdValue;
              // 单位
              this.backPlanWarningForm.unit = res.data.unit;
              this.units = res.data.unitId;
              this.backPlanWarningForm.monitorMode = res.data.monitorMode;
              // 如果监控指标为备份计划时 不显示符号、阈值和单位
              if (this.backPlanWarningForm.monitorIndex == 87) {
                this.isShowField = 1;
              } else {
                this.isShowField = 2;
              }
              // 监控方式
              if (this.backPlanWarningForm.monitorMode == 0) {
                this.isShowField = 1;
              } else {
                this.isShowField = 2;
                // 最小值
                this.backPlanWarningForm.minValue = res.data.minValue;
                // 最大值
                this.backPlanWarningForm.maxValue = res.data.maxValue;
              }
              // 是否显示统计次数
              this.changeShowStatisticsCount();
              // 统计次数
              this.backPlanWarningForm.statisticsCount =
                res.data.statisticsCount;
              if (this.backPlanWarningForm.monitorIndex == 59) {
                this.isShowLogGroupName = true;
                this.logGroupName = res.data.logGroupName;
              }
              this.backPlanWarningForm.contactType = res.data.contactType;
              if (res.data.contactType == 0) {
                // 通知对象
                this.backPlanWarningForm.notificationObject =
                  res.data.contactIDs;
                for (
                  var i = 0;
                  i < this.backPlanWarningForm.notificationObject.length;
                  i++
                ) {
                  for (var j = 0; j < this.notificationObjectList.length; j++) {
                    if (
                      this.backPlanWarningForm.notificationObject[i] ==
                      this.notificationObjectList[j].id
                    ) {
                      this.backPlanWarningForm.userIdList.push(
                        this.notificationObjectList[j].userId
                      ),
                        this.backPlanWarningForm.idList.push(
                          this.notificationObjectList[j].id
                        ); //传值
                    }
                  }
                }
              } else if (res.data.contactType == 1) {
                // 联系人组
                this.$api.contactGroup
                  .listContactGroupsByAccountId(
                    "accountId",
                    this.backPlanWarningForm.account
                  )
                  .then((res) => {
                    this.contactGroupIdList = res.data;
                  });
                setTimeout(() => {
                  this.backPlanWarningForm.contactGroupIds =
                    res.data.contactGroupIds;
                }, 1000);
              }
              // 报警方式
              this.backPlanWarningForm.noticeType = res.data.noticeType;

              for (
                var i = 0;
                i < this.backPlanWarningForm.noticeType.length;
                i++
              ) {
                if (this.backPlanWarningForm.noticeType[i] == "0") {
                  this.isShowEmail = true;
                  this.backPlanWarningForm.emailModal =
                    res.data.briefReportBodyMail;
                  this.noticeType = this.backPlanWarningForm.noticeType;
                  tableDataWarningVue.selectTemplate();
                }
                if (this.backPlanWarningForm.noticeType[i] == "1") {
                  // this.isShowWeChat = true;
                  this.backPlanWarningForm.wechatModal =
                    res.data.briefReportBodyWechat;
                  this.checkLeastOnePersonBoundWeChat();
                  this.noticeType = this.backPlanWarningForm.noticeType;
                  tableDataWarningVue.selectTemplate();
                } else if (this.backPlanWarningForm.noticeType[i] != "1") {
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = false;
                }
                if (this.backPlanWarningForm.noticeType[i] == "2") {
                  // this.isShowPhone = true;
                  this.backPlanWarningForm.phoneModal =
                    res.data.briefReportBodyPhone;
                  this.checkContactPhone();
                  this.noticeType = this.backPlanWarningForm.noticeType;
                  tableDataWarningVue.selectTemplate();
                } else if (this.backPlanWarningForm.noticeType[i] != "2") {
                  this.phoneWarningVisible = false;
                  this.isAddOrEdit = false;
                }
              }
              // 企业微信机器人URL
              this.backPlanWarningForm.enterpriseWechatRobotIds =
                res.data.enterpriseWechatRobotIds;
            });
        } else {
          this.tableBackPlanDate = [];
          this.isEdit = false;
          this.isShowSearch = true;
          // 添加显示规则名称能输入
          this.isEditRuleName = true;
          this.showRuleName = false;
        }
      });
      this.modal = true;
      this.isNext = false;
      this.isPrevious = true;
    },
    // 根据监控指标 显示不同单位
    /****************************************************************/
    // 清空周期、连续周期、统计数值、关系符号
    emptyDate: function () {
      this.backPlanWarningForm.cycle = "";
      this.backPlanWarningForm.continousCycle = "";
      this.backPlanWarningForm.statisticsValue = "";
      this.backPlanWarningForm.statisticsCount = "";
      this.backPlanWarningForm.relationshipSign = "";
      this.backPlanWarningForm.thresholdValue = "";
    },
    isNotEmpty: function (obj) {
      if (typeof obj === "undefined" || obj === null || obj === "") {
        return false;
      } else {
        return true;
      }
    },
    // 根据监控指标 显示不同单位
    changeMonitorIndex: function () {
      // 如果监控指标为备份计划时 不显示符号、阈值和单位
      if (this.backPlanWarningForm.monitorIndex == 1) {
        this.isShowField = 1;
      } else {
        this.isShowField = 2;
        this.changeMonitorMode();
      }
      // 是否显示日志组
      this.changeShowLogGroupName();
      tableDataWarningVue.selectMonitorIndexDefault();
      this.unit = this.backPlanWarningForm.monitorIndex;
      for (var i = 0; i < this.monitorIndexList.length; i++) {
        if (this.monitorIndexList[i].id == this.unit) {
          this.backPlanWarningForm.unit = this.monitorIndexList[i].unit;
          this.units = this.monitorIndexList[i].id;
        }
      }
      tableDataWarningVue.selectTemplate();
      tableDataWarningVue.emptyDate();
    },
    // 查询阈值
    /****************************************************************/
    selectMonitorIndexDefault: function () {
      if (
        this.backPlanWarningForm.account == "" ||
        this.backPlanWarningForm.account == null
      ) {
        return;
      }
      tableDataWarningVue.$api.alertRule
        .selectMonitorIndexDefault({
          monitorItemId: this.monitorItemId,
          monitorIndex: this.backPlanWarningForm.monitorIndex,
          monitorModule: this.monitorModule,
          cycle: this.backPlanWarningForm.cycle,
          continousCycle: this.backPlanWarningForm.continousCycle,
          statisticsValue: this.backPlanWarningForm.statisticsValue,
          statisticsCount: this.backPlanWarningForm.statisticsCount,
          relationshipSign: this.backPlanWarningForm.relationshipSign,
          monitorMode: this.backPlanWarningForm.monitorMode,
          accountId: this.backPlanWarningForm.account,
        })
        .then((res) => {
          // 周期
          this.cycleList = res.data.cycleMap;
          // 连续周期
          this.continousCycleList = res.data.continousCycleMap;
          // 统计数值
          this.statisticsValueList = res.data.statisticsValueMap;
          // 统计次数
          this.statisticsCountList = res.data.statisticsCountMap;
          // 关系符号
          this.relationshipSignList = res.data.relationshipSignMap;
          // 阈值
          if (
            res.data.companyMonitoritemVariablesList.length == 1 &&
            tableDataWarningVue.isNotEmpty(this.backPlanWarningForm.cycle) &&
            tableDataWarningVue.isNotEmpty(
              this.backPlanWarningForm.continousCycle
            ) &&
            tableDataWarningVue.isNotEmpty(
              this.backPlanWarningForm.statisticsValue
            ) &&
            tableDataWarningVue.isNotEmpty(
              this.backPlanWarningForm.statisticsCount
            ) &&
            tableDataWarningVue.isNotEmpty(
              this.backPlanWarningForm.relationshipSign
            ) &&
            this.backPlanWarningForm.id == 0
          ) {
            this.backPlanWarningForm.thresholdValue =
              res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
          }
        });
    },
    // 查询邮件模板
    /****************************************************************/
    selectTemplate: function () {
      tableDataWarningVue.$api.briefReport
        .selectTemplate({
          monitorItemId: this.monitorItemId,
          monitorIndex: this.backPlanWarningForm.monitorIndex,
          relationshipSign: this.backPlanWarningForm.relationshipSign,
          monitorModule: this.monitorModule,
          noticeType: this.backPlanWarningForm.noticeType,
          monitorMode: this.backPlanWarningForm.monitorMode,
        })
        .then((res) => {
          this.backPlanWarningForm.wechatModal = res.data.briefReportBodyWechat;
          this.backPlanWarningForm.emailModal = res.data.briefReportBodyMail;
        });
    },
    //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
    selectnoticeType: function () {
      this.isShowEmail = false;
      this.isShowWeChat = false;
      this.isShowPhone = false;
      for (var i = 0; i < this.backPlanWarningForm.noticeType.length; i++) {
        if (this.backPlanWarningForm.noticeType[i] == "0") {
          this.isShowEmail = true;
          this.noticeType = this.backPlanWarningForm.noticeType;
          tableDataWarningVue.selectTemplate();
        }
        // 微信
        if (this.backPlanWarningForm.noticeType[i] == "1") {
          // this.isShowWeChat = true;
          this.noticeType = this.backPlanWarningForm.noticeType;
          this.checkLeastOnePersonBoundWeChat();
          tableDataWarningVue.selectTemplate();
        } else if (this.backPlanWarningForm.noticeType[i] != "1") {
          this.wechatWarningVisible = false;
          this.isAddOrEdit = false;
        }
        // 电话
        if (this.backPlanWarningForm.noticeType[i] == "2") {
          // this.isShowPhone = true;
          this.noticeType = this.backPlanWarningForm.noticeType;
          this.checkContactPhone();
          tableDataWarningVue.selectTemplate();
        } else if (this.backPlanWarningForm.noticeType[i] != "2") {
          this.phoneWarningVisible = false;
          this.isAddOrEdit = false;
        }
      }
    },
    // 检查至少有一人绑定过微信
    checkLeastOnePersonBoundWeChat: function () {
      for (var i = 0; i < this.backPlanWarningForm.noticeType.length; i++) {
        if (this.backPlanWarningForm.noticeType[i] == 1) {
          var weChatDate = {
            contactType: this.backPlanWarningForm.contactType,
          };
          // 联系方式为 -联系人-
          if (this.backPlanWarningForm.contactType == 0) {
            weChatDate.userIds = this.backPlanWarningForm.idList;
          }
          // 联系方式为 -联系人组-
          else if (this.backPlanWarningForm.contactType == 1) {
            weChatDate.contactGroupIds =
              this.backPlanWarningForm.contactGroupIds;
          }
          this.$api.userWeChat
            .checkLeastOnePersonBoundWeChat(weChatDate)
            .then((res) => {
              if (res.data) {
                // 可以添加告警
                this.wechatWarningVisible = false;
                this.isAddOrEdit = false;
              } else {
                // 不可以添加微信告警
                this.wechatWarningVisible = true;
                this.isAddOrEdit = true;
              }
            });
        } else if (this.backPlanWarningForm.noticeType[i] != 1) {
          this.wechatWarningVisible = false;
          this.isAddOrEdit = false;
        }
      }
    },
    // 检查至少有一人绑定过电话
    checkContactPhone: function () {
      for (var i = 0; i < this.backPlanWarningForm.noticeType.length; i++) {
        if (this.backPlanWarningForm.noticeType[i] == 2) {
          //var phoneDate = [{ id: 328 }, { id: 327 }];
          var phoneDate = {
            contactType: this.backPlanWarningForm.contactType,
          };
          // 联系方式为 -联系人-
          if (this.backPlanWarningForm.contactType == 0) {
            phoneDate.userIds = this.backPlanWarningForm.idList;
          }
          // 联系方式为 -联系人组-
          else if (this.backPlanWarningForm.contactType == 1) {
            phoneDate.contactGroupIds =
              this.backPlanWarningForm.contactGroupIds;
          }

          this.$api.userPhone.checkContactPhone(phoneDate).then((res) => {
            if (res.data) {
              // 可以添加告警
              this.phoneWarningVisible = false;
              this.isAddOrEdit = false;
            } else {
              // 不可以添加电话告警
              this.phoneWarningVisible = true;
              this.isAddOrEdit = true;
            }
          });
        } else if (this.backPlanWarningForm.noticeType[i] != 2) {
          this.phoneWarningVisible = false;
          this.isAddOrEdit = false;
        }
      }
    },
    // 联系人组
    listContactGroups: function () {
      this.$api.contactGroup
        .listContactGroupsByAccountId(
          "accountId",
          this.backPlanWarningForm.account
        )
        .then((res) => {
          this.contactGroupIdList = res.data;
        });
    },
    // 切换联系人组
    changeContactGroupId: function () {
      this.checkLeastOnePersonBoundWeChat();
      this.checkContactPhone();
    },
    // 切换通知对象
    changeNotificationObject: function (val) {
      this.backPlanWarningForm.userIdList = [];
      this.backPlanWarningForm.idList = [];
      this.backPlanWarningForm.notificationObject = val;
      for (
        var i = 0;
        i < this.backPlanWarningForm.notificationObject.length;
        i++
      ) {
        for (var j = 0; j < this.notificationObjectList.length; j++) {
          if (
            this.backPlanWarningForm.notificationObject[i] ==
            this.notificationObjectList[j].id
          ) {
            this.backPlanWarningForm.userIdList.push(
              this.notificationObjectList[j].userId
            ); //传值
            this.backPlanWarningForm.idList.push(
              this.notificationObjectList[j].id
            );
          }
        }
      }
      this.checkLeastOnePersonBoundWeChat();
      this.checkContactPhone();
    },
    // 切换联系方式
    changeContactType: function () {
      this.checkLeastOnePersonBoundWeChat();
      this.checkContactPhone();
    },
    //点击查询 加载全部数据
    /***********************************************************************************/
    searchBackPlanDate: function (backPlanWarningForm) {
      if (
        this.backPlanWarningForm.account == "" ||
        this.backPlanWarningForm.account == null
      ) {
        return;
      }
      this.modal_loadings = true;
      // 根据AccountId查询Instance列表
      var queryDate = {
        accountId: this.backPlanWarningForm.account,
      };
      if (
        this.accountType == 0 ||
        this.accountType == 1 ||
        this.accountType == 2 ||
        this.accountType == 4
      ) {
        queryDate.regions = this.backPlanWarningForm.backupRegion;
      }
      tableDataWarningVue.$api.resourceAwsBackupPlan
        .queryBackupPlans(queryDate)
        .then((res) => {
          this.tableBackPlanDate = res.data;
          console.log(res.data, "data");
          this.modal_loadings = false;
        });
    },

    /**************************************  查询  **************************************/
    // 查询监控指标
    searchMonitorIndex: function () {
      if (this.backPlanWarningForm.monitorMode == 0) {
        tableDataWarningVue.$api.alertRule
          .searchMonitorIndex({
            monitorModule: this.monitorModule,
            accountId: this.backPlanWarningForm.account,
          })
          .then((res) => {
            if (res.data != null && res.data != "" && res.data != undefined) {
              this.monitorIndexList = res.data;
            }
          });
      } else if (this.backPlanWarningForm.monitorMode == 1) {
        tableDataWarningVue.$api.alertRule
          .searchIntervalAlarm({
            monitorModule: this.monitorModule,
            accountType: this.accountType,
          })
          .then((res) => {
            if (res.data != null && res.data != "" && res.data != undefined) {
              this.monitorIndexList = res.data;
            }
          });
      }
    },
    // 查询通知对象
    queryContacts: function () {
      tableDataWarningVue.$api.contact
        .queryContactsByAccountIdAndMonitorModule({
          monitorModule: this.monitorModule,
          accountId: this.backPlanWarningForm.account,
        })
        .then((res) => {
          this.notificationObjectList = res.data.contactList;
          this.backPlanWarningForm.notificationObject =
            res.data.defaultContactIds;
        });
    },
    // 查询监控时间段
    searchMonitorPeriod: function () {
      this.$api.alertRule
        .monitorPeriod("userName", getCookie(global.cookieName))
        .then((res) => {
          this.monitorPeriodList = res.data;
        });
    },
    // 查询报警方式
    alarmWay: function () {
      tableDataWarningVue.$api.alertRule
        .alarmWay("userName", getCookie(global.cookieName))
        .then((res) => {
          this.alarmWayList = res.data;
        });
    },
    // 查询报警延迟
    getAlarmDelay: function () {
      tableDataWarningVue.$api.alertRule
        .alarmDelay("userName", getCookie(global.cookieName))
        .then((res) => {
          this.alarmDelayList = res.data;
        });
    },
    // 周期
    changeCycle: function () {
      // 查询阈值
      tableDataWarningVue.selectMonitorIndexDefault();
    },
    // 连续周期
    changeContinousCycle: function () {
      // 查询阈值
      tableDataWarningVue.selectMonitorIndexDefault();
    },
    // 统计数值
    changeStatisticsValue: function () {
      // 查询阈值
      tableDataWarningVue.selectMonitorIndexDefault();
      // 是否显示统计次数
      this.changeShowStatisticsCount();
    },
    // 是否显示日志组
    changeShowLogGroupName: function () {
      if (this.backPlanWarningForm.monitorIndex == 59) {
        this.isShowLogGroupName = true;
      } else {
        this.isShowLogGroupName = false;
        this.logGroupName = "";
      }
    },
    // 是否显示统计次数
    changeShowStatisticsCount: function () {
      // <!-- 当账号为"Azure"且统计数值为"最大值"时  显示统计次数下拉框 -->
      // <!-- 当账号为"Azure"且统计数值为"磁盘"时  显示统计次数下拉框 -->
      // <!-- 当账号为"AWS"且统计数值为"磁盘"时  显示统计次数下拉框 -->
      // <!-- 当账号为"GCP"且统计数值为"CPU"时  显示统计次数下拉框 -->
      // <!-- 当账号为"GCP"且统计数值为"内存使用率"时  显示统计次数下拉框 -->
      if (
        (this.accountType == 2 &&
          this.backPlanWarningForm.monitorIndex == 613 &&
          this.backPlanWarningForm.statisticsValue == 0) ||
        (this.accountType == 2 &&
          this.backPlanWarningForm.monitorIndex == 614 &&
          this.backPlanWarningForm.statisticsValue == 3) ||
        (this.accountType == 4 &&
          this.backPlanWarningForm.monitorIndex == 1501 &&
          this.backPlanWarningForm.statisticsValue == 0) ||
        (this.accountType == 1 &&
          this.backPlanWarningForm.monitorIndex == 301 &&
          this.backPlanWarningForm.statisticsValue == 0) ||
        (this.accountType == 1 &&
          this.backPlanWarningForm.monitorIndex == 302 &&
          this.backPlanWarningForm.statisticsValue == 0) ||
        (this.accountType == 1 &&
          this.backPlanWarningForm.monitorIndex == 303 &&
          this.backPlanWarningForm.statisticsValue == 0) ||
        (this.accountType == 0 && this.backPlanWarningForm.statisticsValue == 0)
      ) {
        if (this.backPlanWarningForm.monitorMode == 0) {
          this.isShowStatisticsCount = true;
        } else {
          // 区间告警不需要显示统计次数
          this.isShowStatisticsCount = false;
        }
      } else {
        this.isShowStatisticsCount = false;
      }
    },
    // 统计次数
    changeStatisticsCount: function () {
      // 查询阈值
      tableDataWarningVue.selectMonitorIndexDefault();
    },
    // 关系符号
    changeRelationshipSign: function () {
      // 查询阈值
      tableDataWarningVue.selectMonitorIndexDefault();
      // 邮件模板
      tableDataWarningVue.selectTemplate();
    },
    // 根据用户名查询Account列表
    getAccount: function () {
      // 清空表格
      this.tableBackPlanDate = [];
      tableDataWarningVue.$api.account
        .queryAccounts("userName", getCookie(global.cookieName))
        .then((res) => {
          this.accountList = res.data;
          for (var i = 0; i < this.accountList.length; i++) {
            this.accountList[i].name =
              this.accountList[i].name +
              "(" +
              this.accountList[i].accountTypeName +
              ")";
          }
        });
      // 查询方式
      tableDataWarningVue.alarmWay();
      // 查询报警延时
      tableDataWarningVue.getAlarmDelay();
      // 监控时段
      tableDataWarningVue.searchMonitorPeriod();
      // 监控模块查询关联的机器人列表
      tableDataWarningVue.listEnterpriseWechatRobotsByMonitorModule();
    },
    // 监控模块查询关联的机器人列表
    listEnterpriseWechatRobotsByMonitorModule: function () {
      tableDataWarningVue.$api.enterpriseWechatRobot
        .listEnterpriseWechatRobotsByMonitorModule({
          monitorModule: this.monitorModule,
        })
        .then((res) => {
          this.enterpriseWechatRobotIdsList = res.data;
        });
    },
    //获取自己要的属性
    getMoreParams: function (params) {
      //账号类型
      this.accountType = params.type;
    },
    // 选择账户
    changeAccount: function () {
      if (
        this.backPlanWarningForm.account == "" ||
        this.backPlanWarningForm.account == null
      ) {
        return;
      }

      // 清空表格
      this.tableBackPlanDate = [];
      this.instanceList = [];
      this.isShowSearch = true;
      this.isNextClick = true;
      this.backPlanWarningForm.backupRegion = [];
      tableDataWarningVue.$api.account
        .queryAccountRegions("accountId", this.backPlanWarningForm.account)
        .then((res) => {
          this.backupRegionList = res.data;
        });
      // 查询通知对象
      tableDataWarningVue.queryContacts();
      // 查询联系人组
      tableDataWarningVue.listContactGroups();
    },
    /***********存储区域**************************/
    selectBackupRegionAll() {
      this.backPlanWarningForm.backupRegion = [];
      if (this.singleBackupRegion) {
        this.backupRegionList.map((item) => {
          this.backPlanWarningForm.backupRegion.push(item.name);
        });
      } else {
        this.backPlanWarningForm.backupRegion = [];
      }
    },
    // 切换存储区域
    changebackupRegion: function (val) {
      if (val.length === this.backupRegionList.length && val.length != 0) {
        this.singleBackupRegion = true;
      } else {
        this.singleBackupRegion = false;
      }
      // 表格数据为空、显示查询按钮、存储区域为空
      this.tableBackPlanDate = [];
      this.instanceList = [];
      this.isShowSearch = true;
      this.isNextClick = true;
    },
    // 全选 单选
    /***********************************************************************************/
    // 单选
    selectChange(selection) {
      // 所有数据
      this.selection = selection;
      // 清空数组
      this.newTableBackPlanDataList = [];
      for (var i = 0; i < this.selection.length; i++) {
        var TableBackPlanCopy = new Object();
        TableBackPlanCopy.backupPlanId = this.selection[i].backupPlanId;
        TableBackPlanCopy.name = this.selection[i].name;
        TableBackPlanCopy.privateIp = this.selection[i].privateIp;
        TableBackPlanCopy.state = this.selection[i].state;
        TableBackPlanCopy.region = this.selection[i].region;
        TableBackPlanCopy.accountId = this.selection[i].accountId;
        this.newTableBackPlanDataList.push(TableBackPlanCopy);
      }
      // 选了数据 可以点击下一步
      if (this.newTableBackPlanDataList.length == 0) {
        this.isNextClick = true;
      } else {
        this.isNextClick = false;
      }
    },
    // 全选
    selectAll: function (selection) {
      // 所有数据
      this.selection = selection;
      // 清空数组
      this.newTableBackPlanDataList = [];
      for (var i = 0; i < this.selection.length; i++) {
        var TableBackPlanCopy = new Object();
        TableBackPlanCopy.backupPlanId = this.selection[i].backupPlanId;
        TableBackPlanCopy.name = this.selection[i].name;
        TableBackPlanCopy.privateIp = this.selection[i].privateIp;
        TableBackPlanCopy.state = this.selection[i].state;
        TableBackPlanCopy.region = this.selection[i].region;
        TableBackPlanCopy.accountId = this.selection[i].accountId;
        this.newTableBackPlanDataList.push(TableBackPlanCopy);
      }
      if (this.selection.length == 0) {
        this.isNextClick = true;
      } else {
        this.isNextClick = false;
      }
    },
    // 创建添加或编辑报警
    /**********************************************************************************/
    ok: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          var alertList = {
            minValue: this.backPlanWarningForm.minValue,
            maxValue: this.backPlanWarningForm.maxValue,
            monitorMode: this.backPlanWarningForm.monitorMode,
            alertRuleName: this.backPlanWarningForm.ruleName,
            monitorIndex: this.backPlanWarningForm.monitorIndex,
            cycle: this.backPlanWarningForm.cycle,
            continousCycle: this.backPlanWarningForm.continousCycle,
            statisticsValue: this.backPlanWarningForm.statisticsValue,
            statisticsCount: this.backPlanWarningForm.statisticsCount,
            relationshipSign: this.backPlanWarningForm.relationshipSign,
            accountId: this.backPlanWarningForm.account,
            monitorModule: this.monitorModule,
            noticeType: this.backPlanWarningForm.noticeType,
            unit: this.units,
            delay: this.backPlanWarningForm.alarmDelay,
            monitorPeriod: this.backPlanWarningForm.monitorPeriod,
            contactType: this.backPlanWarningForm.contactType,
            enterpriseWechatRobotIds:
              this.backPlanWarningForm.enterpriseWechatRobotIds,
          };

          // 如果监控指标为实例健康状态或者系统健康状态
          if (
            this.backPlanWarningForm.monitorIndex == 7 ||
            this.backPlanWarningForm.monitorIndex == 8 ||
            this.backPlanWarningForm.monitorIndex == 87
          ) {
            alertList.thresholdValue = 1;
          } else {
            alertList.thresholdValue = this.backPlanWarningForm.thresholdValue;
          }

          if (this.backPlanWarningForm.monitorIndex == 59) {
            alertList.logGroupName = this.logGroupName;
          }

          // 如果联系方式是联系人 传通知对象
          if (this.backPlanWarningForm.contactType == 0) {
            alertList.contactIDs = this.backPlanWarningForm.notificationObject;
          }
          // 如果联系方式是联系人组 传联系人组
          else if (this.backPlanWarningForm.contactType == 1) {
            alertList.contactGroupIds =
              this.backPlanWarningForm.contactGroupIds;
          }

          if (this.backPlanWarningForm.id > 0) {
            alertList.id = this.backPlanWarningForm.id;
            alertList.awsBackupPlanDTOList = this.newTableBackPlanDataList;
            // 编辑告警
            this.addloading = true;
            tableDataWarningVue.$api.alertRule
              .updateAlertRule(alertList)
              .then((res) => {
                this.data = res.data;
                setTimeout(() => {
                  this.reload();
                  tableBackPlan.methods.showAll();
                  this.backPlanWarningForm.notificationObject = [];
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$emit("on-ok", this.form);
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success(this.$t("common.editSuccess"));
                  // 禁止点击下一步
                  this.isNextClick = true;
                  this.isShowSearch = false;
                  this.isShowEmail = false;
                  this.isShowWeChat = false;
                  this.addloading = false;
                  this.modal = false;
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = true;
                }, 1000);
              });
          } else {
            // 添加告警
            this.addloading = true;
            alertList.awsBackupPlanDTOList = this.newTableBackPlanDataList;
            tableDataWarningVue.$api.alertRule
              .createAlertRule(alertList)
              .then((res) => {
                this.data = res.data;
                setTimeout(() => {
                  this.reload();
                  tableBackPlan.methods.showAll();
                  this.backPlanWarningForm.notificationObject = [];
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$emit("on-ok", this.form);
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success(this.$t("common.addSuccess"));
                  // 禁止点击下一步
                  this.isNextClick = true;
                  this.isShowEmail = false;
                  this.isShowWeChat = false;
                  this.addloading = false;
                  this.modal = false;
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = true;
                }, 1000);
              });
          }
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          if (this.backPlanWarningForm.id > 0) {
            this.$Message.error(this.$t("common.editFail"));
          } else {
            this.$Message.error(this.$t("common.addFail"));
          }
        }
      });
    },
    // 取消
    cancel: function (name) {
      this.isAddOrEdit = true;
      this.wechatWarningVisible = false;
      this.isShowSearch = false;
      this.isShowEmail = false;
      this.isShowWeChat = false;
      this.isNextClick = true;
      this.modal = false;
      this.$emit("on-cancel");
      this.backPlanWarningForm.notificationObject = [];
      this.$nextTick(() => {
        this.$refs[name].resetFields();
      });
      // 清空表格
      this.tableBackPlanDate = [];
    },
    /**
     * 切换监控方式
     */
    changeMonitorMode: function () {
      if (this.backPlanWarningForm.monitorMode == 0) {
        this.isShowField = 1;
      } else {
        this.isShowField = 2;
      }
      this.searchMonitorIndex();
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/backPlan/AddOrUpdateBackPlanWarning.vue